import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const RegistrationCompletePage = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('app_token');
    if (token) {
      try {
        const decodedUser = jwtDecode(token);
        setUser(decodedUser);
      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, []);

  return (
    <div className="registration-complete-page">
      <div className="completion-card">
        <span className="completion-icon material-icons">check_circle</span>
        <h2 className="completion-title">Registration Complete!</h2>
        <p className="completion-message">
          Thank you for registering! A confirmation email with the course details and meeting link has been sent to you.
        </p>
        {user && user.role === 'admin' && (
          <Link to="/courses" className="completion-button">
            Explore More Courses
          </Link>
        )}
      </div>
    </div>
  );
};

export default RegistrationCompletePage;
